// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.Accordion_accordion__LJMti {
  width: 100%;
  padding: 20px 0;
  border-bottom: 2px solid rgba(255, 255, 255, 0.5);
  font-family: "Montserrat", sans-serif;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.Accordion_accordion__LJMti .Accordion_header__NwLuo {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  width: 76%;
}
.Accordion_accordion__LJMti .Accordion_header__NwLuo .Accordion_headerTitle__3-JoV {
  font-weight: 500;
  font-size: 30px;
  line-height: 60px;
  color: rgb(255, 255, 255);
  cursor: pointer;
  display: flex;
  gap: 20px;
  align-items: center;
}
.Accordion_accordion__LJMti .Accordion_header__NwLuo .Accordion_headerTitle__3-JoV .Accordion_tooltipLink__ZJ-mF {
  position: relative;
  display: flex;
}
.Accordion_accordion__LJMti .Accordion_header__NwLuo .Accordion_headerTitle__3-JoV .Accordion_tooltipLink__ZJ-mF:hover .Accordion_tooltipText__T\\+Ect {
  visibility: visible;
  opacity: 1;
}
.Accordion_accordion__LJMti .Accordion_header__NwLuo .Accordion_headerTitle__3-JoV .Accordion_tooltipLink__ZJ-mF .Accordion_tooltipText__T\\+Ect {
  display: flex;
  align-items: center;
  gap: 8px;
  visibility: hidden;
  width: fit-content;
  white-space: nowrap;
  background-color: rgba(255, 255, 255, 0.4);
  color: #fff;
  border-radius: 12px;
  padding: 8px 20px;
  position: absolute;
  z-index: 1;
  bottom: 35px;
  left: 20px;
  margin-left: -60px;
  opacity: 0;
  transition: opacity 0.3s;
  font-family: "Montserrat";
  font-size: 12px;
  font-weight: 500;
  line-height: 0;
  text-align: left;
}
.Accordion_accordion__LJMti .Accordion_header__NwLuo .Accordion_headerTitle__3-JoV .Accordion_tooltipLink__ZJ-mF .Accordion_tooltipText__T\\+Ect img {
  width: 20px;
  height: 20px;
}
.Accordion_accordion__LJMti .Accordion_header__NwLuo .Accordion_headerTitle__3-JoV .Accordion_tooltipLink__ZJ-mF .Accordion_tooltipText__T\\+Ect:after {
  content: "";
  position: absolute;
  top: 100%; /* Внизу подсказки */
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: rgba(255, 255, 255, 0.4) transparent transparent transparent;
}
@media screen and (max-width: 1440px) {
  .Accordion_accordion__LJMti .Accordion_header__NwLuo .Accordion_headerTitle__3-JoV {
    font-size: 20px;
    line-height: 24px;
  }
}
@media screen and (max-width: 767px) {
  .Accordion_accordion__LJMti .Accordion_header__NwLuo .Accordion_headerTitle__3-JoV {
    font-size: 16px;
    line-height: 17px;
  }
}
.Accordion_accordion__LJMti .Accordion_header__NwLuo button {
  border: none;
  background-color: inherit;
  font-size: 50px;
  height: 34px;
  opacity: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgb(255, 255, 255);
  cursor: pointer;
  text-align: center;
  vertical-align: center;
}
@media screen and (max-width: 1440px) {
  .Accordion_accordion__LJMti .Accordion_header__NwLuo button > img {
    width: 26px;
    height: 26px;
  }
}
@media screen and (max-width: 767px) {
  .Accordion_accordion__LJMti .Accordion_header__NwLuo button > img {
    width: 20px;
    height: 20px;
  }
}
@media screen and (max-width: 767px) {
  .Accordion_accordion__LJMti .Accordion_header__NwLuo {
    width: 90%;
  }
}
@media screen and (max-width: 480px) {
  .Accordion_accordion__LJMti .Accordion_header__NwLuo {
    width: 100%;
  }
}
.Accordion_accordion__LJMti .Accordion_content__T8zYr {
  transition: all 0.3s ease-out;
  opacity: 0;
  max-height: 0;
  overflow: hidden;
  cursor: pointer;
  width: 76%;
}
.Accordion_accordion__LJMti .Accordion_content__T8zYr.Accordion_expanded__MgziL {
  opacity: 1;
  margin-top: 15px;
  margin-bottom: 15px;
  max-height: none;
}
.Accordion_accordion__LJMti .Accordion_content__T8zYr .Accordion_text__9oXIb {
  font-size: 24px;
  font-weight: 400;
  line-height: 40px;
  text-align: left !important;
  color: #FFFFFF;
}
.Accordion_accordion__LJMti .Accordion_content__T8zYr .Accordion_text__9oXIb img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
@media screen and (max-width: 1440px) {
  .Accordion_accordion__LJMti .Accordion_content__T8zYr .Accordion_text__9oXIb {
    font-size: 16px;
    line-height: 20px;
  }
}
@media screen and (max-width: 767px) {
  .Accordion_accordion__LJMti .Accordion_content__T8zYr .Accordion_text__9oXIb {
    font-size: 14px;
    line-height: 15px;
  }
}
@media screen and (max-width: 767px) {
  .Accordion_accordion__LJMti .Accordion_content__T8zYr {
    width: 90%;
  }
}
@media screen and (max-width: 480px) {
  .Accordion_accordion__LJMti .Accordion_content__T8zYr {
    width: 100%;
  }
}
.Accordion_accordion__LJMti .Accordion_buttonWrapper__AT\\+7j {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 24px;
}
@media screen and (max-width: 767px) {
  .Accordion_accordion__LJMti .Accordion_buttonWrapper__AT\\+7j {
    width: 100%;
  }
}
.Accordion_accordion__LJMti .Accordion_contactUsButton__ZYgvI {
  padding: 23px 28px;
  width: 304px;
  border-radius: 10px;
  font-weight: 700;
  font-size: 28px;
  line-height: 34px;
  text-align: center;
  cursor: pointer;
  border: 2px solid #FFFFFF;
  background: transparent;
  color: #FFFFFF;
  margin-left: 40px;
}
.Accordion_accordion__LJMti .Accordion_contactUsButton__ZYgvI:disabled {
  background: lightgray;
  color: grey;
  border: 2px solid grey;
}
.Accordion_accordion__LJMti .Accordion_contactUsButton__ZYgvI:hover {
  border: 2px solid rgba(255, 255, 255, 0.8);
}
@media screen and (max-width: 767px) {
  .Accordion_accordion__LJMti .Accordion_contactUsButton__ZYgvI {
    width: 200px;
    padding: 13px 28px;
    font-size: 18px;
    line-height: 22px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/accordion/Accordion.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,WAAA;EACA,eAAA;EACA,iDAAA;EACA,qCAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AAEF;AAAE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,UAAA;AAEJ;AAAI;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EAEA,eAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;AACN;AACM;EACE,kBAAA;EACA,aAAA;AACR;AACQ;EACE,mBAAA;EACA,UAAA;AACV;AAEQ;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,0CAAA;EACA,WAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;EACA,wBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAAV;AAEU;EACE,WAAA;EACA,YAAA;AAAZ;AAEU;EACE,WAAA;EACA,kBAAA;EACA,SAAA,EAAA,oBAAA;EACA,SAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,0EAAA;AAAZ;AAKM;EA7DF;IA8DI,eAAA;IACA,iBAAA;EAFN;AACF;AAIM;EAlEF;IAmEI,eAAA;IACA,iBAAA;EADN;AACF;AAII;EACE,YAAA;EACA,yBAAA;EACA,eAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;AAFN;AAIM;EACE;IACE,WAAA;IACA,YAAA;EAFR;AACF;AAKM;EACE;IACE,WAAA;IACA,YAAA;EAHR;AACF;AAOI;EA5GF;IA6GI,UAAA;EAJJ;AACF;AAMI;EAhHF;IAiHI,WAAA;EAHJ;AACF;AAME;EACE,6BAAA;EACA,UAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,UAAA;AAJJ;AAMI;EACE,UAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AAJN;AAOI;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,2BAAA;EACA,cAAA;AALN;AAOM;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AALR;AAOM;EAZF;IAaI,eAAA;IACA,iBAAA;EAJN;AACF;AAMM;EAjBF;IAkBI,eAAA;IACA,iBAAA;EAHN;AACF;AAMI;EAtCF;IAuCI,UAAA;EAHJ;AACF;AAKI;EA1CF;IA2CI,WAAA;EAFJ;AACF;AAKE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AAHJ;AAKI;EANF;IAOI,WAAA;EAFJ;AACF;AAKE;EACE,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,uBAAA;EACA,cAAA;EACA,iBAAA;AAHJ;AAKI;EACE,qBAAA;EACA,WAAA;EACA,sBAAA;AAHN;AAMI;EACE,0CAAA;AAJN;AAOI;EAxBF;IAyBI,YAAA;IACA,kBAAA;IACA,eAAA;IACA,iBAAA;EAJJ;AACF","sourcesContent":[".accordion {\n  width: 100%;\n  padding: 20px 0;\n  border-bottom: 2px solid rgba(255, 255, 255, 0.5);\n  font-family: \"Montserrat\", sans-serif;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n\n  .header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    cursor: pointer;\n    width: 76%;\n\n    .headerTitle {\n      font-weight: 500;\n      font-size: 30px;\n      line-height: 60px;\n      color: rgba(255, 255, 255, 1);\n      //text-transform: uppercase;\n      cursor: pointer;\n      display: flex;\n      gap: 20px;\n      align-items: center;\n\n      .tooltipLink {\n        position: relative;\n        display: flex;\n\n        &:hover .tooltipText {\n          visibility: visible;\n          opacity: 1;\n        }\n\n        .tooltipText {\n          display: flex;\n          align-items: center;\n          gap: 8px;\n          visibility: hidden;\n          width: fit-content;\n          white-space: nowrap;\n          background-color: #FFFFFF66;\n          color: #fff;\n          border-radius: 12px;\n          padding: 8px 20px;\n          position: absolute;\n          z-index: 1;\n          bottom: 35px;\n          left: 20px;\n          margin-left: -60px;\n          opacity: 0;\n          transition: opacity 0.3s;\n          font-family: \"Montserrat\";\n          font-size: 12px;\n          font-weight: 500;\n          line-height: 0;\n          text-align: left;\n\n          img {\n            width: 20px;\n            height: 20px;\n          }\n          &:after {\n            content: \"\";\n            position: absolute;\n            top: 100%; /* Внизу подсказки */\n            left: 50%;\n            margin-left: -5px;\n            border-width: 5px;\n            border-style: solid;\n            border-color: #FFFFFF66 transparent transparent transparent;\n          }\n        }\n      }\n\n      @media screen and (max-width: 1440px) {\n        font-size: 20px;\n        line-height: 24px;\n      }\n\n      @media screen and (max-width: 767px) {\n        font-size: 16px;\n        line-height: 17px;\n      }\n    }\n\n    button {\n      border: none;\n      background-color: inherit;\n      font-size: 50px;\n      height: 34px;\n      opacity: 1;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      color: rgba(255, 255, 255, 1);\n      cursor: pointer;\n      text-align: center;\n      vertical-align: center;\n\n      @media screen and (max-width: 1440px) {\n        > img {\n          width: 26px;\n          height: 26px;\n        }\n      }\n\n      @media screen and (max-width: 767px) {\n        > img {\n          width: 20px;\n          height: 20px;\n        }\n      }\n    }\n\n    @media screen and (max-width: 767px) {\n      width: 90%;\n    }\n\n    @media screen and (max-width: 480px) {\n      width: 100%;\n    }\n  }\n\n  .content {\n    transition: all 0.3s ease-out;\n    opacity: 0;\n    max-height: 0;\n    overflow: hidden;\n    cursor: pointer;\n    width: 76%;\n\n    &.expanded {\n      opacity: 1;\n      margin-top: 15px;\n      margin-bottom: 15px;\n      max-height: none;\n    }\n\n    .text {\n      font-size: 24px;\n      font-weight: 400;\n      line-height: 40px;\n      text-align: left !important;\n      color: #FFFFFF;\n\n      img {\n        width: 100%;\n        height: 100%;\n        object-fit: contain;\n      }\n      @media screen and (max-width: 1440px) {\n        font-size: 16px;\n        line-height: 20px;\n      }\n\n      @media screen and (max-width: 767px) {\n        font-size: 14px;\n        line-height: 15px;\n      }\n    }\n\n    @media screen and (max-width: 767px) {\n      width: 90%;\n    }\n\n    @media screen and (max-width: 480px) {\n      width: 100%;\n    }\n  }\n\n  .buttonWrapper {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-top: 24px;\n\n    @media screen and (max-width: 767px) {\n      width: 100%;\n    }\n  }\n\n  .contactUsButton {\n    padding: 23px 28px;\n    width: 304px;\n    border-radius: 10px;\n    font-weight: 700;\n    font-size: 28px;\n    line-height: 34px;\n    text-align: center;\n    cursor: pointer;\n    border: 2px solid #FFFFFF;\n    background: transparent;\n    color: #FFFFFF;\n    margin-left: 40px;\n\n    &:disabled {\n      background: lightgray;\n      color: grey;\n      border: 2px solid grey;\n    }\n\n    &:hover {\n      border: 2px solid rgba(255, 255, 255, 0.8);\n    }\n\n    @media screen and (max-width: 767px) {\n      width: 200px;\n      padding: 13px 28px;\n      font-size: 18px;\n      line-height: 22px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"accordion": `Accordion_accordion__LJMti`,
	"header": `Accordion_header__NwLuo`,
	"headerTitle": `Accordion_headerTitle__3-JoV`,
	"tooltipLink": `Accordion_tooltipLink__ZJ-mF`,
	"tooltipText": `Accordion_tooltipText__T+Ect`,
	"content": `Accordion_content__T8zYr`,
	"expanded": `Accordion_expanded__MgziL`,
	"text": `Accordion_text__9oXIb`,
	"buttonWrapper": `Accordion_buttonWrapper__AT+7j`,
	"contactUsButton": `Accordion_contactUsButton__ZYgvI`
};
export default ___CSS_LOADER_EXPORT___;
